import React from 'react'
import { Block, Typography } from '@xprog/prensa'
import * as t from './types'


const ContainerButton = (props: t.ContainerProps) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

ContainerButton.defaultProps = {
  defaultCss: {
    width: '100%',
    '@lg': {
      align: ['row', 'center', 'middle'],
    }
  }
}
export {
  ContainerButton
}

const ContainerNewsletter = (props: t.ContainerProps) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

ContainerNewsletter.defaultProps = {
  defaultCss: {
    align: ['column', 'center', 'top'],
    border: '1px solid #E6E6E6',
    display: 'flex',
    height: '100%',
    mx: '$4',
    mt: '$4',
    mb: '$6',
    pb: '$2',
    width: 'calc(100% - 32px)',
    '@lg': {
     maxWidth: '952px' 
    }
  }
}
export {
  ContainerNewsletter
}

const ContainerInputs = (props: t.ContainerProps) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

ContainerInputs.defaultProps = {
  defaultCss: {
    align: ['column', 'left', 'middle'],
    mb: '$2',
    width: 'calc(100% - 16px)',
    '@lg': {
      align: ['row', 'center', 'top'],
      maxWidth: '918px',
      width: 'calc(100% - 48px)',
    }
  }
}
export {
  ContainerInputs
}  

const ContainerSubject = (props: t.ContainerProps) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

ContainerSubject.defaultProps = {
  defaultCss: {
    width: 'calc(100% - 32px)',
    align: ['column', 'left', 'center'],
    '@lg': {
      align: ['row', 'left', 'middle'],
      width: 'calc(100% - 48px)',
    }
  }
}
export {
  ContainerSubject
}

const ContainerTitle = (props: t.ContainerProps) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

ContainerTitle.defaultProps = {
  defaultCss: {
    align: ['row', 'left', 'middle'],
    mb: '$2',
    mt: '$6',
    width: 'calc(100% - 32px)',
  }
}
export {
  ContainerTitle
}

const Subtitle = (props: t.ContainerProps) =>
  <Typography
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Typography>

Subtitle.defaultProps = {
  defaultCss: {
    color: 'black',
    fontFamily: '$primary',
    fontSize: '14px',
    fontWeight: 400,
    m: '$0',
    mb: '$4',
    width: '100%',
    '@lg': {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '25px',
      mb: '$0'
    }
  }
}
export {
  Subtitle
}

const Title = (props: t.ContainerProps) =>
  <Typography
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Typography>

Title.defaultProps = {
  defaultCss: {
    alignItems: 'center',
    color: '#164194',
    fontFamily: '$primary',
    fontSize: '22px',
    fontWeight: 700,
    m: '$0',
    width: 'max-content'
  }
}
export {
  Title
}